import React, { useEffect, useMemo, useState } from "react";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
// import "../../../styles.css";
// import Vectorsorting from "../../../assets/Vectorsorting.svg";
// import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { useSelector } from "react-redux";
import CustomPagination from "../CustomWidgets/CustomPagination";
import Skeleton from "@mui/material/Skeleton";

const ProductExpireTable = ({ additionalData ,pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setFlag] = useState(false);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  const data = useMemo(
    () =>
      additionalData?.status
        ? additionalData?.all_product
        : additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setFlag(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);



const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="text-start justify-start" title={t("Batch Number")}>
                        {t("Batch Number")}
                    </div>
                ),
                accessor: "lot_number",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.lot_number}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Expiring Quantity")}>
                        {t("Expiring Quantity")}
                    </div>
                ),
                accessor: "quantity",
                Cell: ({ row }) => (
                    <div className="text-start">{t(row.original.quantity)}</div>
                ),
            },
             {
                Header: (
                    <div className="text-start" title={t("Manufacture Date")}>
                        {t("Manufacture Date")}
                    </div>
                ),
                accessor: "manufacturing_date",
                Cell: ({ row }) => (
                    <div className="text-start">{row.original.manufacturing_date}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Shelf Life (Days)")}>
                        {t("Shelf Life (Days)")}
                    </div>
                ),
                accessor: "shelf_life_days",
                Cell: ({ row }) => (
                    <div className="text-start">{t(row.original.shelf_life_days)}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Expiring Date")}>
                        {t("Expiring Date")}
                    </div>
                ),
                accessor: "expiry_date",
                Cell: ({ row }) => (
                    <div className="text-start">{row.original.expiry_date}</div>
                ),
            },
{
        Header: t("Status"),
        accessor: "is_expired",
        width: "18%",
        Cell: ({ row }) => (
          <div className="text-start">
            <span
              className={`flex justify-center font-normal text-lg rounded-xl  ${row.original?.is_expired  ? "bg-[#FCE5DC] text-[#991B1B] w-32"
                : 'bg-[#DCFCE7] text-[#166534] w-24' }`}
              style={{
                padding: "0.4rem 0.8rem",
              }}
            >
              {row.original?.is_expired ? t('Expired') : t('Healthy')}
            </span>
          </div>
        ),
      },
            ...(allStores
                ? [
                    {
                        Header: (
                            <div className="text-start justify-start" title={t("Store Name")}>
                                {t("Store Name")}
                            </div>
                        ),
                        accessor: "company_name",
                        headerClassName: "text-start",
                        Cell: ({ row }) => (
                            <div className="text-start justify-start">{row.original.company_name}</div>
                        ),
                    },
                ]
                : []),
                // {
                //             Header: t("Actions"),
                //             accessor: "actions",
                //             width: "10%",
                //             Cell: ({ row }) => (
                //                 <div className="flex gap-2 justify-start">
                //                     <img
                //                         src={Edit}
                //                         className="cursor-pointer h-4 w-4"
                //                         alt="Edit"
                //                         onClick={(e) => {
                //                             e.stopPropagation();
                //                             // onEditLine(row.original);
                //                         }}
                //                     />
                //                     <img
                //                         src={deleteicon}
                //                         className="cursor-pointer h-4 w-4 mx-2"
                //                         alt="Delete"
                //                         onClick={(e) => {
                //                             e.stopPropagation();
                //                             // onDelete(row.original.id);
                //                         }}
                //                     />
                //                 </div>
                //             ),
                //         }

            // {
            //     Header: (
            //         <div className="text-start" title={t("Expiring Alert Days")}>
            //             {t("Expiring Alert Days")}
            //         </div>
            //     ),
            //     accessor: "request_alert_days",
            //     Cell: ({ row }) => (
            //         <div className="text-start">{`${row.original.request_alert_days}`}</div>
            //     ),
            // },
        ],
        [t,allStores]
    );

 const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);
  
      useEffect(() => {
          const pageDetails = {
              limit: pageSize,
              offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
          };
  
          if (pageSize) pagination(pageDetails);
      }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto ms-4 mb-2 mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length === 0 && flag === false ? (
          <div className=" w-[90%] mt-2 ms-4">
          <div className="p-4">
        {[...Array(6)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={index % 2 === 0 ? 40 : 60}
            className="mb-3"
          />
        ))}
      </div>
          </div>
        ) : (
          <>
            <div>
                        <table
                          className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                          style={{ tableLayout: "fixed" }}
                        >
                          <thead>
                            {headerGroups.map((headerGroup, headerIndex) => {
                              const { key: headerKey, ...headerGroupProps } =
                                headerGroup.getHeaderGroupProps();
                              return (
                                <tr
                                  key={headerKey}
                                  {...headerGroupProps}
                                  className="bg-[#78CFEC66] text- font-semibold overflow-hidden whitespace-nowrap"
                                >
                                  {headerGroup.headers.map((column, colIndex) => {
                                    const { key: columnKey, ...columnProps } =
                                      column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      );
                                    return (
                                      <th
                                        key={columnKey}
                                        {...columnProps}
                                        className="py-3 whitespace-nowrap"
                                        style={{ width: column.width }} // Set column width
                                      >
                                        <div className="flex items-start ms-2 text-lg ">
                                          {column.render("Header")}
                                          {/* <span className="">
                                            {column.isSorted ? (
                                              column.isSortedDesc ? (
                                                <img
                                                  src={Vectorsorting}
                                                  style={{ minHeight: 10, minWidth: 10 }}
                                                  alt="vector"
                                                />
                                              ) : (
                                                <img
                                                  className="rotate-180"
                                                  src={Vectorsorting}
                                                  alt="vector"
                                                />
                                              )
                                            ) : (
                                              ""
                                            )}
                                          </span> */}
                                        </div>
                                      </th>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </thead>
                        </table>
                      </div>
          
                      {/* Body Table (Scrollable) */}
                      <div
                        className="scrollbar-none bg-white"
                        style={{
                          overflowY: "auto",
                          maxHeight: "450px", // Adjust height as needed
                        }}
                      >
                        <table
                          className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                          style={{ tableLayout: "fixed" }}
                        >
                          <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <React.Fragment key={row.id}>
                                  <tr
                                    {...row.getRowProps()}
                                    className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                  //   onClick={() => openOrderList(row.original.id)}
                                  >
                                    {row.cells.map((cell, index) => (
                                      <td
                                        key={index}
                                        {...cell.getCellProps()}
                                        className={`p-2 text-[#272728] h-1212 text-lg font-normal ${
                                          index < row.cells.length - 1 ? "relative" : ""
                                        } ${
                                          cell?.column?.Header == "Product"
                                            ? "cursor-pointer"
                                            : ""
                                        }`}
                                          style={{ width: cell.column.width }} // Match column width
                                      >
                                        {cell.render("Cell")}
                                      </td>
                                    ))}
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                            {page.length === 0 && (
                              <tr>
                                <td colSpan={"100%"}>
                                  <Empty
                                    className="mt-10 text-lg mb-10"
                                    description={t("No data available")}
                                  />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="">
                        <CustomPagination
                            data={data?.length}
                            pageIndex={pageIndex}
                            pageCount={page?.length}
                            canPreviousPage={pageIndex != 1 ? true : false}
                            canNextPage={data?.length == pageSize ? true : false}
                            gotoPage={(page) => {
                                nextPage(page);
                            }}
                            previousPage={() => {
                                setpageIndex(pageIndex - 1);
                            }}
                            nextPage={() => {
                                setpageIndex(pageIndex + 1);
                            }}
                            pageSize={pageSize}
                            setPageSize={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                        />
                    </div>
          </>
        )}
      </div>
    </>
  );
};

export default ProductExpireTable;
